import { CommonBlock } from './CommonBlock/ui/CommonBlock.jsx'
export { AddToCart } from './AddToCard/ui/AddToCart.jsx'
export { AddToPreferences } from './AddToPreferences/ui/AddToPreferences.jsx'
export { QuickView } from './QuickView/ui/QuickView.jsx'

export default CommonBlock
